import { useStoreRequired } from 'features/store/hooks/use-store-required';
import { useIntl } from 'react-intl';

import { LocationEmptyState } from 'components/location-empty-state';
import LoyaltyInRestaurantRedemption from 'pages/loyalty/loyalty-in-restaurant-redemption/loyalty-in-restaurant-redemption';

export default function MyCodeScreen() {
  const { noStoreSelected } = useStoreRequired();
  const { formatMessage } = useIntl();

  if (noStoreSelected) {
    return (
      <LocationEmptyState
        title={formatMessage({ id: 'emptyMyCodeHeading' })}
        message={formatMessage({ id: 'emptyMenuMessage' })}
      />
    );
  }

  return <LoyaltyInRestaurantRedemption />;
}
